import { CompartmentCard } from "@/src/components/cards";
import { FetchableList } from "@/src/components/fetchableLists";
import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import { Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { uid } from "@/src/utils/utils";
import { useState } from "react";
import ConsultationCard from "./consultationCard";
import { openConsultationPage } from "../consultation/consultationPage";

export function ConsultationsHistory({ patient }: { patient: Patient }) {
  const [reload, setReload] = useState(0);

 
  return (
    <CompartmentCard
      title={"Consultations"}
      color="blue"
      onClick={async () => {
        await openConsultationPage({
          consultationId: null,
          patient: patient,
          onSave: (consultation) => {
            setReload(reload + 1);
          },
        });
      }}
    >
      <FetchableList
        queryKey={["ConsultationsHistory", patient.id, reload]}
        queryFn={() =>
          apiFetch("consultations", "loadMany", {
            patientId: patient.id,
            sortByDate: true,
          })
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((item, index) => {
              return (
                <StaggeredAnimation key={uid()} index={index}>
                  <ConsultationCard
                    consultation={item}
                    patient={patient}
                    onChange={(consultation) => {
                      setReload(reload + 1);
                    }}
                  />
                </StaggeredAnimation>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}
